import { Skeleton, TableCell, TableRow } from '@mui/material';
import styles from '../PersonalPlanTable.module.scss';

export const PersonalPlanTableSkeleton = () => (
  <TableRow>
    <TableCell colSpan={2}>
      <Skeleton height={30} />
    </TableCell>
    <TableCell align="right" className={styles.currentColumn}>
      <Skeleton height={30} />
    </TableCell>
    <TableCell align="right">
      <Skeleton height={30} />
    </TableCell>
    <TableCell align="right">
      <Skeleton height={30} />
    </TableCell>
    <TableCell align="right">
      <Skeleton height={30} />
    </TableCell>
    <TableCell align="right">
      <Skeleton height={30} />
    </TableCell>
  </TableRow>
);
